import { firebaseConfig } from '@/constants/firebase'
import { initializeApp } from 'firebase/app'

initializeApp(firebaseConfig)
